module.exports = __webpack_public_path__ + "img/9788950955601.843742b9.jpg";